import { FILTER_SEARCH_REQUEST, FILTER_SEARCH_REQUEST_SUCCESS, FILTER_SEARCH_REQUEST_FAILURE } from '../constants/bike_model.constants';

export const filterSearchRequest = where => ({
    type: FILTER_SEARCH_REQUEST, where,
});

export const filterSearchRequestSuccess = payload => ({
    type: FILTER_SEARCH_REQUEST_SUCCESS, payload,
});

export const filterSearchRequestFailure = error => ({
    type: FILTER_SEARCH_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/actions/filter_search.actions.js